export default __webpack_public_path__ + "static/media/Destanee-Webb.53d909f7.jpg";